import type { AgentEditChromeData } from '@atlaskit/editor-common/collab-agent-edit-chrome';
import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';
import { fg } from '@atlaskit/platform-feature-flags/fg';

import type { AgentInfo } from '../decoration/reducer';

type AgentEditChromePresentation = Pick<
	AgentEditChromeData,
	'agentIdentityAccountId' | 'telepointerLabel'
>;

/** Resolves optional agent presentation at the producer boundary. */
export const getAgentEditChromePresentation = (
	agentInfo?: AgentInfo,
): AgentEditChromePresentation => {
	if (!isExperimentEnabled('platform_editor_agent_mentions')) {
		return {};
	}

	if (
		fg('platform_editor_agent_mentions_telepointer_avatar') &&
		agentInfo?.agentIdentityAccountId
	) {
		return { agentIdentityAccountId: agentInfo.agentIdentityAccountId };
	}

	return agentInfo?.agentName ? { telepointerLabel: agentInfo.agentName } : {};
};
